import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "locale", "product", "teamPermissions", "teamPermissionCheckEnabled", "orgId"];
import React, { createContext } from 'react';
import { FlightDeckProvider } from '@atlassiansox/flight-deck-frontend-client';
import { usePeopleAndTeamsRemoteArtifact } from '../flight-deck';
import { DEFAULT_CONTEXT } from './constants';
import { usePeopleAndTeamsConfigurationOverrides } from './hooks/usePeopleAndTeamsConfigurationOverrides';
export var PeopleAndTeamsConfigurationContext = /*#__PURE__*/createContext(DEFAULT_CONTEXT);
export var PeopleAndTeamsBasicConfigurationProvider = function PeopleAndTeamsBasicConfigurationProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale,
    product = _ref.product,
    teamPermissions = _ref.teamPermissions,
    orgId = _ref.orgId,
    _ref$teamPermissionCh = _ref.teamPermissionCheckEnabled,
    teamPermissionCheckEnabled = _ref$teamPermissionCh === void 0 ? false : _ref$teamPermissionCh;
  var overrides = usePeopleAndTeamsConfigurationOverrides(teamPermissionCheckEnabled, orgId, teamPermissions);
  var artifact = usePeopleAndTeamsRemoteArtifact(product, locale, overrides);
  return /*#__PURE__*/React.createElement(PeopleAndTeamsConfigurationContext.Provider, {
    value: artifact || DEFAULT_CONTEXT
  }, children);
};
export var PeopleAndTeamsConfigurationProvider = function PeopleAndTeamsConfigurationProvider(_ref2) {
  var children = _ref2.children,
    locale = _ref2.locale,
    product = _ref2.product,
    teamPermissions = _ref2.teamPermissions,
    teamPermissionCheckEnabled = _ref2.teamPermissionCheckEnabled,
    orgId = _ref2.orgId,
    flightDeckProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(FlightDeckProvider, _extends({
    product: product
  }, flightDeckProps), /*#__PURE__*/React.createElement(PeopleAndTeamsBasicConfigurationProvider, {
    locale: locale,
    product: product,
    teamPermissions: teamPermissions,
    teamPermissionCheckEnabled: teamPermissionCheckEnabled,
    orgId: orgId
  }, children));
};
export var usePeopleAndTeamsConfigurationContext = function usePeopleAndTeamsConfigurationContext() {
  return React.useContext(PeopleAndTeamsConfigurationContext);
};